export default __webpack_public_path__ + "static/media/hibernate-svg.07a9f554.png";